<div (click)="_onClick($event)" >
  <i
  class="eye"
  [ngClass]="visible ? 'fa fa-eye' : 'fa fa-eye-slash'"
  ></i>
</div>
